const { HTMLElementExt } = await import(
    window._resolveImport?.("html-element-ext") || "html-element-ext"
);

class HeaderMenu extends HTMLElementExt {
    constructor() {
        super();

        this.querySelectorAll("[data-items-menu] details").forEach((detail) => {
            // remove dropdown menu links if config option is checked
            this.removeDropdownMenuLinks(detail);

            // open megamenu dropdown inner
            if (detail.lastElementChild.dataset.typeMenu == "full-width") {
                detail.setAttribute("open", true);
                // set dropdown inner max-height (Fix for Firefox and Safari browsers)
                this.setMaxHeight(detail);
            }
        });

        this.handles = {
            "toggle::[data-items-menu] details": async (event) => {
                const helper = await import(
                    window._resolveImport?.("helper") || "helper"
                );
                const details = event.target;
                const _getDropdown = (d) =>
                    [...d.children].find((el) => el.tagName !== "SUMMARY");
                const _trapIntoParent = (el) => {
                    let details = el.closest("details[open]");
                    details && helper.trapFocus(_getDropdown(details));
                };

                if (details.open) {
                    window.requestAnimationFrame(() => {
                        details.dataset.active = "true";
                        helper.trapFocus(_getDropdown(details));
                    }, 200);
                } else {
                    helper.removeTrapFocus();
                    _trapIntoParent(details);
                }
            },
        };

        let menu = this.querySelector(".header__inline-menu > ul");
        if (menu?.dataset?.activateMenu == "on_click") {
            this.handles["click::[data-items-menu] details"] =
                this.activateItemMenuOnClick.bind(this);
        } else {
            this.handles["mouseenter::[data-items-menu] details"] =
                this.activateItemMenuOnHover.bind(this);
        }
    }

    activateItemMenuOnClick(e) {
        let detail = e.target.closest("details");

        if (
            detail.parentElement.nodeName === "DETAILS-DISCLOSURE" &&
            e.target.nodeName !== "A"
        ) {
            e.preventDefault();
            e.stopPropagation();

            this.activateItemMenu(detail);
        }
    }

    activateItemMenuOnHover(e) {
        const detail = e.target.closest("details");
        const mouseleaveHandle = (event) => {
            this.diactivateItemMenu(event);
            detail.removeEventListener("mouseleave", mouseleaveHandle);
        };

        // megamenu dropdown inner - prevent hiding child menu on leaving parent caterory item
        if (
            detail.lastElementChild.dataset.typeMenu == "full-width" &&
            detail.closest("ul.header__submenu")
        )
            return;

        this.activateItemMenu(detail);
        detail.addEventListener("mouseleave", mouseleaveHandle);
    }

    activateItemMenu(detail) {
        detail.open = true;
    }

    diactivateItemMenu(event) {
        const detail = event.target;

        detail.dataset.active = "false";
        setTimeout(() => {
            detail.open = detail.dataset.active === "true";
        }, 300);
    }

    removeDropdownMenuLinks(detail) {
        let dropdownInner = detail.closest(".dropdown-inner");

        if (
            dropdownInner?.classList.contains("full-width") &&
            dropdownInner?.firstElementChild?.classList.contains("remove-menu")
        ) {
            dropdownInner.querySelector(
                ".col-items"
            ).dataset.menuRemoved = true;
            dropdownInner.querySelector(".col-items").children[0].remove();
        }
    }

    setMaxHeight(detail) {
        let dropdownInner = detail.closest(".dropdown-inner");
        if (!dropdownInner) return;

        let inner_height = window.innerHeight,
            inner_width = window.innerWidth;

        if (inner_width < 980) return;

        let headerSectionHeight = document.querySelectorAll(
                ".shopify-section-group-header-group"
            ),
            sum = 0;

        headerSectionHeight?.forEach((el) => {
            if (el.id.indexOf("_header") > 0) sum += el.offsetHeight; // get all header top sections height
        });

        dropdownInner.style.maxHeight = inner_height - sum + "px";
        dropdownInner.style.overflowX = "auto";
    }
}

export { HeaderMenu };
